const productstyle = {
    totalno: {
        display: "flex",
        flexDirection: "row", // Align items horizontally
        justifyContent: "space-between", // Add spacing between elements
        alignItems: "center",
        flexWrap: "wrap", // Allow items to wrap for smaller screens
        padding: "10px", // Add padding for spacing
    },
    filterstyle: {
        position: "relative",
        width: "180px",
    },
    imagestyle: {
        position: "absolute",
        left: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        height: "16px", // Adjust as needed
        width: "16px", // Adjust as needed
    },
    inputstyle: {
        color: "#636980",
        background: "none",
        border: "1px solid #E2E2E8",
        width: "100%",
        fontSize: "14px",
        fontWeight: "400",
        borderRadius: "24px",
        paddingLeft: "36px", // Add padding to prevent overlap with the image
        height: "32px", // Adjust as needed
        outline: "none",
    },
    meadd: {
        paddingLeft: "20px",
        paddingRight: "20px",
        backgroundColor: "rgb(45,83,218)",
        outline: "none",
        fontSize: "16px",
        borderRadius: "4px",
        width: "150px",
    },
};

export default productstyle;